import { render, staticRenderFns } from "./edit-customer-store.vue?vue&type=template&id=2e702dbc&scoped=true&"
import script from "./edit-customer-store.vue?vue&type=script&lang=js&"
export * from "./edit-customer-store.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e702dbc",
  null
  
)

export default component.exports